module.exports = __webpack_public_path__ + "media/app/assets/races/tauren_female-cf2bdad53224aad5a7efbe7b8d9de554.png";